import {
  IPaymentStatus,
  PaymentIntentState,
  PaymentMethod,
} from '@kinet-open-network/shared/data-access/model';

export class PaymentStatus implements IPaymentStatus {
  paymentId!: string;
  state!: PaymentIntentState;
  settled!: boolean;
  amount!: number;
  paymentMethod!: PaymentMethod;
  error?:
    | {
        code: string;
        message?: string;
        id?: string;
      }
    | undefined;

  constructor(data: Partial<PaymentStatus>) {
    Object.assign(this, data);
  }
}
